import { render } from "./ResultDirect.vue?vue&type=template&id=13290477&scoped=true"
import script from "./ResultDirect.vue?vue&type=script&lang=js"
export * from "./ResultDirect.vue?vue&type=script&lang=js"

import "./ResultDirect.vue?vue&type=style&index=0&id=13290477&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13290477"]])

export default __exports__